// Each glyph is an actual grid of voxels; no image or text texture is used.
export const glyphs: Record<string, string[]> = {
	S: ["01111", "10000", "10000", "01110", "00001", "00001", "11110"],
	P: ["11110", "10001", "10001", "11110", "10000", "10000", "10000"],
	T: ["11111", "00100", "00100", "00100", "00100", "00100", "00100"],
	L: ["10000", "10000", "10000", "10000", "10000", "10000", "11111"],
	M: ["10001", "11011", "10101", "10101", "10001", "10001", "10001"],
	I: ["111", "010", "010", "010", "010", "010", "111"],
	a: ["00000", "00000", "01110", "00001", "01111", "10001", "01111"],
	c: ["00000", "00000", "01111", "10000", "10000", "10000", "01111"],
	d: ["00001", "00001", "01111", "10001", "10001", "10001", "01111"],
	e: ["00000", "00000", "01110", "10001", "11111", "10000", "01111"],
	h: ["10000", "10000", "10110", "11001", "10001", "10001", "10001"],
	i: ["1", "0", "1", "1", "1", "1", "1"],
	l: ["10", "10", "10", "10", "10", "10", "01"],
	m: ["00000", "00000", "11010", "10101", "10101", "10101", "10101"],
	n: ["00000", "00000", "10110", "11001", "10001", "10001", "10001"],
	o: ["00000", "00000", "01110", "10001", "10001", "10001", "01110"],
	p: ["00000", "00000", "11110", "10001", "11110", "10000", "10000"],
	s: ["00000", "00000", "01111", "10000", "01110", "00001", "11110"],
	t: ["010", "010", "111", "010", "010", "010", "001"],
	y: ["00000", "00000", "10001", "10001", "01111", "00001", "01110"],
	"@": ["01110", "10001", "10111", "10101", "10111", "10000", "01111"],
	".": ["0", "0", "0", "0", "0", "1", "1"],
	",": ["00", "00", "00", "00", "00", "01", "10"],
	" ": ["000", "000", "000", "000", "000", "000", "000"],
};

// Complete the original display alphabet so profile edits do not depend on the
// small subset of characters used by the initial business card.
Object.assign(glyphs, {
	"&": ["01100", "10010", "10100", "01000", "10101", "10010", "01101"],
	"(": ["001", "010", "100", "100", "100", "010", "001"],
	")": ["100", "010", "001", "001", "001", "010", "100"],
	"?": ["01110", "10001", "00001", "00010", "00100", "00000", "00100"],
	"!": ["1", "1", "1", "1", "1", "0", "1"],
	A: ["01110", "10001", "10001", "11111", "10001", "10001", "10001"],
	B: ["11110", "10001", "10001", "11110", "10001", "10001", "11110"],
	C: ["01111", "10000", "10000", "10000", "10000", "10000", "01111"],
	D: ["11110", "10001", "10001", "10001", "10001", "10001", "11110"],
	E: ["11111", "10000", "10000", "11110", "10000", "10000", "11111"],
	F: ["11111", "10000", "10000", "11110", "10000", "10000", "10000"],
	G: ["01111", "10000", "10000", "10111", "10001", "10001", "01111"],
	H: ["10001", "10001", "10001", "11111", "10001", "10001", "10001"],
	J: ["00111", "00010", "00010", "00010", "10010", "10010", "01100"],
	K: ["10001", "10010", "10100", "11000", "10100", "10010", "10001"],
	N: ["10001", "11001", "11001", "10101", "10011", "10011", "10001"],
	O: ["01110", "10001", "10001", "10001", "10001", "10001", "01110"],
	Q: ["01110", "10001", "10001", "10001", "10101", "10010", "01101"],
	R: ["11110", "10001", "10001", "11110", "10100", "10010", "10001"],
	U: ["10001", "10001", "10001", "10001", "10001", "10001", "01110"],
	V: ["10001", "10001", "10001", "10001", "10001", "01010", "00100"],
	W: ["10001", "10001", "10001", "10101", "10101", "10101", "01010"],
	X: ["10001", "10001", "01010", "00100", "01010", "10001", "10001"],
	Y: ["10001", "10001", "01010", "00100", "00100", "00100", "00100"],
	Z: ["11111", "00001", "00010", "00100", "01000", "10000", "11111"],
	"0": ["01110", "10001", "10011", "10101", "11001", "10001", "01110"],
	"1": ["010", "110", "010", "010", "010", "010", "111"],
	"2": ["01110", "10001", "00001", "00010", "00100", "01000", "11111"],
	"3": ["11110", "00001", "00001", "01110", "00001", "00001", "11110"],
	"4": ["10010", "10010", "10010", "11111", "00010", "00010", "00010"],
	"5": ["11111", "10000", "10000", "11110", "00001", "00001", "11110"],
	"6": ["01110", "10000", "10000", "11110", "10001", "10001", "01110"],
	"7": ["11111", "00001", "00010", "00100", "01000", "01000", "01000"],
	"8": ["01110", "10001", "10001", "01110", "10001", "10001", "01110"],
	"9": ["01110", "10001", "10001", "01111", "00001", "00001", "01110"],
	"-": ["000", "000", "000", "111", "000", "000", "000"],
	_: ["00000", "00000", "00000", "00000", "00000", "00000", "11111"],
	"+": ["00000", "00100", "00100", "11111", "00100", "00100", "00000"],
	"/": ["00001", "00001", "00010", "00100", "01000", "10000", "10000"],
	":": ["0", "1", "1", "0", "1", "1", "0"],
	"'": ["1", "1", "0", "0", "0", "0", "0"],
});
for (const character of "ABCDEFGHIJKLMNOPQRSTUVWXYZ") {
	glyphs[character.toLowerCase()] ??= glyphs[character];
}
